import { createActionGroup, props } from '@ngrx/store';
import { ClientUser, PublicUser } from '@pixacare/domain';
import { USERS_FEATURE_KEY } from './users.selectors';

export const usersActions = createActionGroup({
  source: USERS_FEATURE_KEY,
  events: {
    'Add users success': props<{ clientUsers: ClientUser[] }>(),

    'Update users': props<{ users: PublicUser[] }>(),

    'Remove user': props<{ userId: number }>(),
  },
});
